import '@swiatstron/jquery.typographer/dist/jquery.typographer.orphan.min';

jQuery(document).ready(function () {
  // Open menu
  jQuery(".menu-item--expanded span").on("click", function () {
    if (jQuery(this).next(".menu").hasClass('is-active')) {
      jQuery(this).next(".menu").removeClass("is-active");
    } else {
      jQuery('.menu .is-active').removeClass('is-active');
      jQuery(this).next(".menu").addClass("is-active");
      jQuery(this).closest('ul').addClass('is-active');
    }
  });

  // Change order
  const pages = [
    '.node-id-81 #block-aglomeracja-page-title',
    '.node-id-82 #block-aglomeracja-page-title',
    '.node-id-83 #block-aglomeracja-page-title',
    '.node-id-84 #block-aglomeracja-page-title'
  ]
  jQuery(pages.join(', ')).insertAfter('.field--name-field-featured-image').find('h1').removeClass('page-title')

  // Search
  jQuery('.view-header .form-search').on('keyup', function (e) {
    jQuery('.view-content .item-list ul li').each(function () {
      let text = jQuery(this).find('a').text().toLowerCase()
      if (text.indexOf(e.target.value.toLowerCase()) === -1) {
        jQuery(this).addClass('d-none');
      } else {
        jQuery(this).removeClass('d-none');
      }
    })
  })

  // Mobile menu
  jQuery(".menu--mobile-button").on("click", function () {
    jQuery(".menu--main .menu").toggleClass('active');
  })

  // Open WCAG Menu After Click:
  jQuery("button.eye").on("click", function () {
    jQuery(this).parent().toggleClass("active");
  });

  jQuery('body').typographer_orphan({
    forbidden: [
      'a',
      'i',
      'o',
      'u',
      'w',
      'z'
    ]
  });

  jQuery('.form-item-search-api-fulltext label').addClass('sr-only');

  // Move Label on Focus:
  const floatingLabelElements = [
    '.block-formblock-contact input[type="text"]',
    '.block-formblock-contact input[type="email"]',
    ".block-formblock-contact textarea",
  ];
  jQuery(floatingLabelElements.join(", ")).ready(function () {
    jQuery.each(floatingLabelElements, function (index, value) {
      if (jQuery(value).val()) {
        if (jQuery(value).is("textarea")) {
          jQuery(value).parent().prev().addClass("active");
        } else {
          jQuery(value).prev().addClass("active");
        }
      }
    })
    jQuery(floatingLabelElements.join(", "))
      .focus(function () {
        if (jQuery(this).is("textarea")) {
          jQuery(this).attr("rows", 5);
          jQuery(this).parent().prev().addClass("active");
        } else {
          jQuery(this).prev().addClass("active");
        }
      })
      .blur(function () {
        if (!jQuery(this).val()) {
          if (jQuery(this).is("textarea")) {
            jQuery(this).parent().prev().removeClass("active");
          } else {
            jQuery(this).prev().removeClass("active");
          }
        }
      });
  })

  jQuery('#edit-field-zgoda-value--description').ready(function () {
    const label = jQuery('#edit-field-zgoda-value--description').addClass('d-none').html()
    jQuery('.form-item-field-zgoda-value label').html(label)

    jQuery('.show-hide-label a').on('click', function (e) {
      jQuery('.show-hide-label a').addClass('d-none')
      jQuery(this).removeClass('d-none')
      jQuery('.information').toggleClass('d-none')
      e.preventDefault();
    })
  })

  function checkLocalStorage(className) {
    const names = [
      "contrast",
      "space-line",
      "space-word",
      "space-letter",
      "font-minus",
      "font-plus",
    ];
    jQuery(names).each(function () {
      if (localStorage.getItem(this) === null && className === this) {
        localStorage.setItem(this, this);
      } else if (localStorage.getItem(this) !== null && className === this) {
        localStorage.removeItem(this);
      }

      if (className === "font-plus") {
        localStorage.removeItem("font-minus");
      } else if (className === "font-minus") {
        localStorage.removeItem("font-plus");
      }
    });
  }

  function getLocalStorage() {
    const names = [
      "contrast",
      "space-line",
      "space-word",
      "space-letter",
      "font-minus",
      "font-plus",
    ];
    jQuery(names).each(function () {
      if (localStorage.getItem(this) !== null) {
        jQuery("html").addClass(localStorage.getItem(this));
      }
    });
  }

  // WCAG Options:
  jQuery("button[data-class]").click(function () {
    const className = jQuery(this).data("class");
    const body = jQuery("html");
    if (className === "font-reset") {
      body.removeClass("font-minus font-plus");
    } else {
      body.toggleClass(className);

      if (className === "font-minus") body.removeClass("font-plus");

      if (className === "font-plus") body.removeClass("font-minus");

      checkLocalStorage(className);
    }
  });
  getLocalStorage();

  // Attachments:
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  // Remove localStorage Mail and name

  localStorage.removeItem('Drupal.visitor.mail')
  localStorage.removeItem('Drupal.visitor.name')

  const files = document.querySelectorAll('a[data-entity-type="file"]');
  files.forEach((file) => {
    file.classList = "attachment__link";
    const wrapper = document.createElement("div");
    wrapper.classList = "attachment";
    const details = document.createElement("span");
    const button = file.cloneNode();
    button.innerText = "pobierz";
    button.classList = "attachment__button custom-button";
    details.className = "attachment__details";
    details.innerText = `Trwa pobieranie danych...`;
    file.parentNode.insertBefore(wrapper, file);
    wrapper.appendChild(file);
    wrapper.appendChild(details);
    wrapper.appendChild(button);
    if (file) {
      const href = file.getAttribute("href");
      const extension = href.split(".").pop().toUpperCase();
      const request = jQuery.ajax({
        type: "head",
        url: href,
        success: function () {
          const bytes = request.getResponseHeader("Content-Length");
          const size = formatBytes(bytes);
          details.innerText = `${size} | ${extension}`;
        },
        error: function () {
          details.innerText = "";
        },
      });
    }
  });
});
